module.exports = __webpack_public_path__ + "static/media/star-with-border.6ebf4682.svg";